export function generateFilename(filename) {
  var nowMilli = Date.now();
  return nowMilli + "." + filename.split(".").pop();
}
